import { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import { DeleteUser } from "../User/Infrastructure/User.presenter";
import { GetCollects } from "../Delivery/Infrastructure/Delivery.presenter";
import { GetShops } from "../User/Infrastructure/User.presenter";
import FlatIconButton from "./FlatButton";
import RatingStars from "./RatingStars";
import img from "../assets/default.png";
import { GetRating } from "../User/Infrastructure/User.presenter";
import StaticDatePicker from "./StaticDatePicker";
import Collapse from "@mui/material/Collapse";
import createNewChat from "../Chat/Application/createChat.logic";

const iconBtnStyles = {
  width: { xs: "60px", md: "70px" },
  height: "31px",
  background: "#F2F2F2",
  borderRadius: "5px",
  color: "4F4F4F",
  ":hover": {
    background: "#BDBDBD",
  },
};

const acceptBtnStyles = {
  background: "#004990",
  ":hover": {
    background: "#004E9C",
  },
};

const deleteBtn = {
  alignSelf: "start",
  boxShadow: "none",
  fontSize: "0.875rem",
  fontWeight: 700,
  background: "white",
  color: "#EA5B13",
  width: "100px",
  ":hover": {
    boxShadow: "none",
    backgroundColor: "#F2F2F2",
  },
};

const addVehicle = {
  textAlign: "center",
  boxShadow: "none",
  fontSize: { xs: "10px", sm: "11px", md: "0.875rem" },
  fontWeight: 400,
  height: 31,
  ":hover": {
    boxShadow: "none",
  },
};

const btnExitStyles = {
  position: "absolute",
  top: "0px",
  right: "20px",
  color: "#004990",
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
};

const downArrowStyles = {
  ":hover": {
    background: "#F2F2F2",
    borderRadius: "50%",
    cursor: "pointer",
  },
};

const useStyles = makeStyles((theme) => ({
  headerRegister: {
    paddingTop: 30,
    paddingLeft: 15,
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    gap: 50,
    //border: "3px solid red",
    [theme.breakpoints.up("md")]: {
      justifyContent: "center",
      display: "none",
    },
  },
  containerInfo: {
    marginTop: 10,
    width: "100%",
    //maxHeight: 519,
    margin: "auto",
    position: "relative",
    padding: "5px 20px 30px",
    background: "white",
    borderRadius: 10,
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 25,
  },
  userMainInfo: {
    marginTop: 50,
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    gap: 20,
  },
  profileImage: {
    width: 115,
    height: 99,
    objectFit: "cover",
    borderRadius: 5,
    [theme.breakpoints.down("sm")]: {
      width: 70,
      height: 70,
    },
  },
  userName: {
    fontSize: "1.125rem",
    lineHeight: "21.94px",
    color: "#4F4F4F",
  },
  rating: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "end",
    fontSize: "0.875rem",
    lineHeight: "17.07px",
  },
  labelStyles: {
    fontSize: "1.125rem",
    fontWeight: 500,
    color: "#333333",
  },
  roleNameContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      gap: 5,
    },
    //border: "1px solid orange"
  },
  roleName: {
    fontSize: "0.875rem",
    color: "#4F4F4F",
    lineHeight: "17.07px",
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
    },
  },
  rangeDatesContainer: {
    /* fontSize: "0.875rem",
    color:"#4F4F4F",
    lineHeight: "17.07px",
    fontWeight: 500, */
    display: "flex",
    justifyContent: "flex-end",
    gap: 5,
    alignItems: "center",
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  amountContainer: {
    position: "relative",
    width: 104,
    height: 104,
    borderRadius: "50%",
    border: "7px solid #004990",
  },
  amountNum: {
    textAlign: "center",
    //border: "1px solid blue",
    width: 50,
    color: "#4F4F4F",
    fontSize: "1.875rem",
    lineHeight: "36px",
    position: "absolute",
    left: "calc(50% - 25px)",
    top: "calc(50% - 18px)",
  },
  btnContainer: {
    //filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))",
    width: "100%",
    //border: "1px solid blue",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 5,
    [theme.breakpoints.up("md")]: {
      gridColumn: "1/-1",
      //border: "1px solid green",
    },
  },
  btnAdviserContainer: {
    //filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))",
    marginTop: 8,
    width: "100%",
    //border: "1px solid blue",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 8,
  },
  rangeDates: {
    fontSize: "0.875rem",
    color: "#4F4F4F",
    lineHeight: "17.07px",
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
  },
  idVehicle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 170,
    height: "31px",
    background: "#F2F2F2",
    borderRadius: "5px",
    color: "4F4F4F",
    ":hover": {
      background: "#BDBDBD",
    },
  },
}));

const formatDate = (date) => {
  return moment(date).format("DD/MM/YYYY");
};

const getNextSevenDays = (date) => {
  const formatedDate = new Date(date);
  const WeekInMs = 1000 * 60 * 60 * 24 * 7;
  const suma = formatedDate.getTime() + WeekInMs;
  return new Date(suma);
};

export default function ModalProfile({
  isOpen,
  name,
  lastName,
  role,
  profileImage,
  handleModal,
  id,
  vehicle,
  handleDeletedUser,
}) {
  const todayDate = new Date();
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(true);
  const [stars, setStars] = useState(0);
  const [selectedDate, setSelectedDate] = useState(todayDate);
  const [nextWeek, setNextWeek] = useState(getNextSevenDays(todayDate));
  const [isDatePickerOpen, setDatePicker] = useState(false);
  const [collects, setCollects] = useState(0);
  const [shops, setShops] = useState(0);
  
  const UserRating = async () => {
    const response = await GetRating(id);
    if (isNaN(response)) {
      setStars(0);
    } else {
      setStars(response.toFixed(1));
    }
  };

  const DeliveryCollects = async () => {
    try {
      const response = await GetCollects({
        id,
        startDate: selectedDate.toISOString().slice(0, -1),
        endDate: moment(nextWeek).toISOString().slice(0, -1),
      });
      setCollects(response);
    } catch (error) {
      console.log("error al pedir collects", error);
    }
  };

  const AdviserShops = async () => {
    try {
      const response = await GetShops({
        id,
        startDate: selectedDate.toISOString().slice(0, -1),
        endDate: moment(nextWeek).toISOString().slice(0, -1),
      });
      setShops(response);
    } catch (error) {
      console.log("error al pedir shops", error);
    }
  };

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen && role === "repartidor") {
      UserRating();
      DeliveryCollects();
    } else if (isOpen && role === "afiliador") {
      AdviserShops();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, role]);

  const handleClose = () => {
    setOpen(false);
    setSelectedDate(todayDate);
    setNextWeek(getNextSevenDays(todayDate));
    setShops(0);
    setCollects(0);
    handleModal(false);
    handleDeletedUser(false);
  };

  const handleDelete = async () => {
    try {
      await DeleteUser({ id, zone: "" });
      handleClose();
      handleDeletedUser(true);
    } catch (error) {
      alert(error);
    }
  };

  const handleDatePicker = () => {
    setDatePicker(!isDatePickerOpen);
    if (!isDatePickerOpen) {
      setSelectedDate(selectedDate);
    }
  };

  const getDateValue = async (date) => {
    setSelectedDate(date);
    setNextWeek(getNextSevenDays(date));
  };

  const handleAcceptDatePicker = async () => {
    setDatePicker(false);
    role === "repartidor" ? DeliveryCollects() : AdviserShops();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={handleClose}
    >
      <div className={classes.containerInfo}>
        <IconButton sx={btnExitStyles} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <div className={classes.userMainInfo}>
          <img
            className={classes.profileImage}
            src={profileImage === null ? img : profileImage}
            alt="foto de perfil usuario"
          />
          <div>
            <h4 className={classes.userName}>{`${name} ${lastName}`}</h4>
              {role === "repartidor" ? (
                <div className={classes.rating}>
                  {stars}
                  <RatingStars rating={stars} />
                </div>
              ) : (
                <div className={classes.btnAdviserContainer}>
                  <IconButton
                    sx={iconBtnStyles}
                    onClick={async () => {
                      const chatID = await createNewChat(id);
                      history.push(`/chat/${chatID}`);
                    }}
                  >
                    <MessageOutlinedIcon />
                  </IconButton>
                  <IconButton sx={iconBtnStyles}>
                    <LocalPhoneOutlinedIcon />
                  </IconButton>
                </div>
              )}
          </div>
        </div>
        {role === "repartidor" && (
          <div className={classes.btnContainer}>
            <IconButton
              sx={iconBtnStyles}
              onClick={async () => {
                const chatID = await createNewChat(id);
                history.push(`/chat/${chatID}`);
              }}
            >
              <MessageOutlinedIcon />
            </IconButton>
            <IconButton sx={iconBtnStyles}>
              <LocalPhoneOutlinedIcon />
            </IconButton>
            {vehicle ? (
              <p className={classes.idVehicle}>{vehicle}</p>
            ) : (
              <FlatIconButton
                widthBtn="170px"
                typeButton="button"
                title="Agregar vehículo"
                customStyles={addVehicle}
              />
            )}
            {/* <FlatIconButton widthBtn="170px" typeButton="button" title="Agregar vehículo" customStyles={addVehicle}/> */}
          </div>
        )}
        <div className={classes.roleNameContainer}>
          <p className={classes.roleName}>
            {role === "repartidor" ? "Repartos" : "Afiliaciones"}
          </p>
          <div className={classes.rangeDatesContainer}>
            <p className={classes.rangeDates}>
              {formatDate(selectedDate)} - {formatDate(nextWeek)}
            </p>
            {isDatePickerOpen ? (
              <KeyboardArrowUpRoundedIcon
                sx={downArrowStyles}
                onClick={handleDatePicker}
              />
            ) : (
              <KeyboardArrowDownRoundedIcon
                sx={downArrowStyles}
                onClick={handleDatePicker}
              />
            )}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <Collapse
            sx={{ textAlign: "right", width: "100%" }}
            in={isDatePickerOpen}
            timeout="auto"
            unmountOnExit
          >
            <StaticDatePicker
              displayStaticWrapperAs="mobile"
              dateValue={selectedDate}
              handleDateChange={getDateValue}
              handleAccept={handleAcceptDatePicker}
            />
            <FlatIconButton
              title="Aceptar"
              widthBtn="80px"
              customStyles={acceptBtnStyles}
              onClick={handleAcceptDatePicker}
            />
          </Collapse>
        </div>
        <div className={classes.amountContainer}>
          <p className={classes.amountNum}>
            {role === "repartidor" ? collects : shops}
          </p>
        </div>
        {/* <div style={{ alignSelf: "start"}}>
          <FlatIconButton
            width="100px"
            title="Eliminar"
            icon={<DeleteOutlineOutlinedIcon />}
            customStyles={deleteBtn}
            onClick={handleDelete}
          />
        </div> */}
      </div>
    </Dialog>
  );
}
